/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useState } from "react";
import { Input} from "reactstrap";
import { UniqKey } from "../../../util/Key";
import { contrastingForegroundColor } from "../../../util/Color";
import ModalColorPicker from "./ModalColorPicker";
import LayoutFormButton from "./LayoutFormButton";

const LayoutColorForm = ({config, alpha = false, onContentChange}) => {
  // state
  const initialState = {
    color: config ?? (alpha ? "#00000080" : "#000000"),
    validColor: true,
    showModal: false,
    inputKey: config
  };
  const [state, setState] = useState(initialState);

  // handlers
  const setColor = (color, render = true) => {
    // validate color
    const hexColorRegex = alpha ? /^#[0-9A-Fa-f]{8}$/ : /^#[0-9A-Fa-f]{6}$/;
    const valid = hexColorRegex.test(color);

    // update state
    const renderKey = render ? { inputKey: UniqKey() } : {};
    setState(prevState => ({
      ...prevState,
      ...renderKey,
      color: color,
      validColor: valid
    }));

    // return new color if valid
    if (valid) {
      onContentChange(color.toUpperCase());
    }
  };

  // set state
  const setShowModal = (show) => {
    setState(prevState => ({
      ...prevState,
      showModal: show
    }));
  }

  return (
    <div className="d-flex justify-content-center align-items-center">
      <Input
        key={state.inputKey}
        defaultValue={config}
        onChange={(event) => setColor(event.target.value, false)}
        invalid={!state.validColor}
        maxLength={alpha ? 9 : 7}
      />
      <LayoutFormButton
        className="ms-2"
        icon="eyedropper"
        onClick={() => setShowModal(true)}
        style={{
          backgroundColor: state.validColor ? state.color.slice(0, 7) : "",
          color: state.validColor ? contrastingForegroundColor(state.color) : ""
        }}
      />
      <ModalColorPicker
        isOpen={state.showModal}
        toggle={() => setShowModal(false)}
        alpha={alpha}
        color={state.validColor ? state.color : (alpha ? "#000000FF" : "#000000")}
        onChange={setColor}
      />
    </div>
  );
};

export default LayoutColorForm;
